import * as ReactIntl from 'react-intl';

export const FormattedDate = ReactIntl.FormattedDate;
